export enum MenuTypes {
  MenuMobile = 'menu-mobile',
  MenuSubHidden = 'menu-sub-hidden',
  MenuHidden = 'menu-hidden',
  MenuDefault = 'menu-default'
}
